import React, { useState } from 'react';
import styles from './HatvComponent.module.scss';
import HatvSubheader from './HatvSubheaderComponent/HatvSubheader';
import HATVLandingPage from './HATVLandingPage/HATVLandingPage';
import ABOList from './ABOList/ABOList';
import { useLocation } from 'react-router-dom';

const HatvComponent: React.FC = () => {
  const location = useLocation();
  const navigatedFrom = location.state?.from;

  return (
    <section className={`${styles.hatv_main_container}`} data-testid="hatv_testID">
      <div className={styles.hatv_sub_header}>
        <HatvSubheader />
      </div>
      <div className={`${styles.hatv_outer_container}`}>
        <div className={styles.landing_page}>
          <ABOList navigatedFrom={navigatedFrom} />
        </div>
      </div>
    </section>
  );
};

export default HatvComponent;
